import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const LoginCards = ({ cards }) => {
    const { t } = useTranslation();
  const cardsContent = cards.map(card => (
    <div key={card.id}>
      <img
        alt="Baylor Scott & White Health"
        className="login-card-image"
        src={card.img}
      />
      <div className="login-card-text">
        <div className="login-card-heading">{card.heading}</div>
              <div className="login-card-heading">{t("My Way")}</div>
        <div className="login-card-body">{card.body}</div>
      </div>
    </div>
  ));

  return <div className="login-cards">{cardsContent}</div>;
};

LoginCards.defaultProps = {
  cards: [],
};

LoginCards.propTypes = {
  cards: PropTypes.array,
};

export default LoginCards;
